import { Box, Button, Stack, Typography } from '@mui/material';
import { mobileBarStyles } from './eventDetailsStyles';
import { formatCurrency } from './eventDetailsUtils';

const MobileRegistrationBar = ({ selectedSession, selectedTicket, totalPrice, disabled, onConfirm }) => (
  <Box sx={mobileBarStyles.shell}>
    <Stack direction="row" spacing={1.5} alignItems="stretch" justifyContent="space-between">
      <Box sx={mobileBarStyles.content}>
        <Typography variant="caption" color="text.secondary" sx={mobileBarStyles.detailText}>
          {selectedSession ? selectedSession.title : 'Select session'}
        </Typography>
        <Typography variant="caption" color="text.secondary" sx={mobileBarStyles.detailText}>
          {selectedTicket ? selectedTicket.label : 'Select ticket'}
        </Typography>
        <Typography sx={mobileBarStyles.amount}>{formatCurrency(totalPrice)}</Typography>
      </Box>
      <Button variant="contained" disabled={disabled} onClick={onConfirm} sx={mobileBarStyles.button}>Confirm &amp; Continue</Button>
    </Stack>
  </Box>
);

export default MobileRegistrationBar;
